import Vue from 'vue'
import Vuex from 'vuex'
import user from './user'
import shared from './shared'
import branch from './branch'
import notification from './notification'
import restriction from './restriction'
import cases from './case'
import recommendations from './recommendation'
import point from './point'
import product from './product'
import photo from './photo'
import agent from './agent'
import driver from './driver'
import monitoring from './monitoring'
import userGroup from './user-group'
import statistics from './statistics'
import settings from './settings'
import chat from './chat'
import stock from './stock'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    apiUrl: 'https://backendv2.producto.store:746',
    chatServer: 'http://localhost:3000',
    chatFileServer: 'http://localhost:3001',
    pageTitle: 'PRODUCTO'
  },
  mutations: {
    setPageTitle (state, payload) {
      state.pageTitle = payload
    }
  },
  modules: {
    user, shared, branch, notification, restriction, point, product, photo, cases, recommendations, monitoring, agent, driver, userGroup, statistics, settings, chat, stock
  },
  getters: {
    apiUrl (state) {
      return state.apiUrl
    },
    pageTitle (state) {
      return state.pageTitle
    },
    chatServer (state) {
      return state.chatServer
    },
    chatFileServer (state) {
      return state.chatFileServer
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js